import translations from './translations'

translations.add('is', {
    closePaymentMethods: 'loka greiðslumáta',
    otherPaymentMethods: 'aðrir greiðslumátar '
})
